import { IJsonDate } from "../../../../../react-core/Utils/JsonDateParser";
import { DemandTypeClient } from "../../../../../Wrap/Api/Instruction/DemandType";
import { DemandTypeModel } from "../../../../../Wrap/Models/Domains/Workflow/DemandTypeModel";

export interface IDemandTypeSearchQuery {
    DemandType: number;
    DemandLvl: number;
    DemandTypeDs: string;
    DemandFullDs: string;
    StopDate: IJsonDate;
}

export class DemandTypeAction {
    public static searchHistoricWorkflows(
        query: IDemandTypeSearchQuery,
        callBack?: (val: DemandTypeModel[]) => void
    ): void {
        const client = new DemandTypeClient();
        const promise = client.get(
            query.DemandType,
            query.DemandLvl,
            query.DemandTypeDs,
            query.DemandFullDs,
            query.StopDate
        );
        promise.onSuccess((res) => {
            callBack(res);
        });
    }
}
